import { motion } from 'framer-motion'
import PropTypes from 'prop-types'

import { Root } from './Hamburger.style'

const Hamburger = ({ isOpen = false }) => {
  const variant = isOpen ? 'opened' : 'closed'

  const top = {
    closed: {
      rotate: 0,
      translateY: 0,
    },
    opened: {
      rotate: 45,
      translateY: 7.5,
    },
  }
  const center = {
    closed: {
      opacity: 1,
    },
    opened: {
      opacity: 0,
    },
  }
  const bottom = {
    closed: {
      rotate: 0,
      translateY: 0,
    },
    opened: {
      rotate: -45,
      translateY: -7.5,
    },
  }

  const width = 15
  const height = 17

  const lineProps = {
    stroke: '#1E1E1F',
    strokeWidth: 1,
    vectorEffect: 'non-scaling-stroke',
    initial: 'closed',
    animate: variant,
    ...lineProps,
  }

  return (
    <Root>
      <motion.svg
        viewBox={`0 0 ${width} ${height}`}
        preserveAspectRatio="none"
        width={width}
        height={height}
        overflow="visible"
      >
        <motion.line x1="0" x2={width} y1="1" y2="1" variants={top} {...lineProps} transition={{ ease: 'easeOut' }} />
        <motion.line
          x1="0"
          x2={width}
          y1={height / 2}
          y2={height / 2}
          variants={center}
          {...lineProps}
          transition={{ duration: 0.1 }}
        />
        <motion.line
          x1="0"
          x2={width}
          y1={height - 1}
          y2={height - 1}
          variants={bottom}
          {...lineProps}
          transition={{ ease: 'easeOut' }}
        />
      </motion.svg>
    </Root>
  )
}

Hamburger.propTypes = {
  isOpen: PropTypes.bool,
}

Hamburger.defaultProps = {}

export default Hamburger
